<p-drawer id="sidebar_fdid_view" styleClass="u ui-sidebar-lg"
    [style]="{ 'width': 'auto', 'max-width': '500px', 'height': 'auto', 'overflow-y': 'auto', 'max-height': '100%'}"
    position="right" [(visible)]="displaySideBar" (onHide)="onClickCancelFDID(false)">
    @if(isLoadingResults){
    <div class="example-loading-shade">
        @if(isLoadingResults){
        <mat-spinner></mat-spinner>}
    </div>}
    <div class="ui-grid ui-grid-responsive ui-fluid">
        <div>
            <h3 class="ui-grid-col-12">FDID Details</h3>
            <div class="ui-grid-col-12">
                <div class="ui-grid-col-3 quick-view-grid-row">
                    <label for="CatReporterIMID">CatReporterIMID</label>
                </div>
                <div lass="ui-grid-col-9 quick-view-grid-row">
                    <input type="text" id="ip_fdid_catReporterIMID" ngDefaultControl
                        [(ngModel)]="selectedFDID.catReporterIMID" [disabled]="viewFDIDOpen" />
                </div>
            </div>
            <div class="ui-grid-col-12">
                <div class="ui-grid-col-3 quick-view-grid-row">
                    <label for="AccountNumber">Account Number</label>
                </div>
                <div lass="ui-grid-col-9 quick-view-grid-row">
                    <input id="ip_fdid_accountNumber" type="text" ngDefaultControl
                        [(ngModel)]="selectedFDID.accountNumber" [disabled]="viewFDIDOpen" />
                </div>
            </div>
            <div class="ui-grid-col-12">
                <div class="ui-grid-col-3 quick-view-grid-row">
                    <label for="Name">Name</label>
                </div>
                <div lass="ui-grid-col-9 quick-view-grid-row">
                    <input id="ip_fdid_name" type="text" ngDefaultControl [(ngModel)]="selectedFDID.name"
                        [disabled]="viewFDIDOpen" />
                </div>
            </div>
            <div class="ui-grid-col-12">
                <div class="ui-grid-col-3 quick-view-grid-row">
                    <label for="GivenName">Given Name</label>
                </div>
                <div lass="ui-grid-col-9 quick-view-grid-row">
                    <input id="ip_fdid_givenname" type="text" ngDefaultControl [(ngModel)]="selectedFDID.givenName"
                        [disabled]="viewFDIDOpen" />
                </div>
            </div>

            <div class="ui-grid-col-12">
                <div class="ui-grid-col-3 quick-view-grid-row">
                    <label for="ReceivedFDID">Received FDID</label>
                </div>
                <div lass="ui-grid-col-9 quick-view-grid-row">
                    <input id="ip_fdid_receivedfdid" type="text" ngDefaultControl
                        [(ngModel)]="selectedFDID.receivedFDID" [disabled]="viewFDIDOpen || !checked" />
                </div>
            </div>
            <div class="ui-grid-col-12">
                <div class="ui-grid-col-3 quick-view-grid-row">
                    <label for="GeneratedFDID">Generated FDID</label>
                </div>
                <div lass="ui-grid-col-9 quick-view-grid-row">
                    <input id="ip_fdid_generatedFDID" type="text" ngDefaultControl
                        [(ngModel)]="selectedFDID.generatedFDID" disabled />
                </div>
            </div>
            <div class="ui-grid-col-12">
                <div class="ui-grid-col-3 quick-view-grid-row">
                    <label for="Active">Active</label>
                </div>
                <div lass="ui-grid-col-9 quick-view-grid-row">
                    <input id="ip_fdid_active" type="text" ngDefaultControl [(ngModel)]="selectedFDID.active"
                        [disabled]="viewFDIDOpen" />
                </div>
            </div>
            <div class="ui-grid-col-12 buttonStyle">
                <button pButton type="button" (click)="onClickCancelFDID(false)" label="Close"
                    class="ui-button-danger ui-grid-col-1 btn-style pull-right userActionBtn"></button>
                <button pButton type="button" (click)="AddCaisFDID()" label="Add CAIS FDID"
                    class="ui-button-danger ui-grid-col-1 btn-styleAdd pull-right userActionBtn"></button>
            </div>
        </div>
    </div>
</p-drawer>